import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        width: '100%',
        border: `1.5px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        backgroundColor: theme.colors.white,
        padding: theme.spacing(4),
        marginBottom: theme.spacing(3),
        [theme.down('tablet')]: {
            padding: theme.spacing(3),
        },
    },
    title: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
        margin: 0,
    },
    subtitle: {
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        color: theme.colors.grey_text,
        margin: `${theme.spacing(0.5)}px 0 0`,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: theme.spacing(3),
        marginTop: theme.spacing(3),
        [theme.down('desktop')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.down('mobile')]: {
            gridTemplateColumns: '1fr',
        },
    },
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        padding: theme.spacing(3),
        border: `1.5px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        backgroundColor: theme.colors.white,
        textDecoration: 'none',
        transition: '0.2s ease',

        '&:hover': {
            borderColor: theme.colors.violet_primary,
            boxShadow: `0 4px 12px 0 ${theme.colors.transp_violet}`,
            transform: 'translateY(-2px)',
            cursor: 'pointer',
        },

        '&:focus-visible': {
            outline: 'none',
            borderColor: theme.colors.violet_primary,
            boxShadow: `0 0 4px 0 ${theme.colors.violet_primary}`,
        },
    },
    icon: {
        color: theme.colors.violet_primary,
        fontSize: 32,
    },
    externalIcon: {
        position: 'absolute',
        top: theme.spacing(2),
        right: theme.spacing(2),
        color: theme.colors.grey_text,
        fontSize: 18,
    },
    cardTitle: {
        fontFamily: theme.font.secondary,
        fontSize: 16,
        lineHeight: 1.4,
        color: theme.colors.black,
        margin: 0,
    },
    cardDescription: {
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        color: theme.colors.grey_text,
        margin: 0,
    },
}));
